export const copy = <T>(obj?: T): T | undefined => {
  if (!obj) {
    return undefined
  }
  return JSON.parse(JSON.stringify(obj));
}

export const copyStrict = <T>(obj: T): T  => {
  return JSON.parse(JSON.stringify(obj));
}